import {createGlobalStyle} from 'styled-components'
import {darkGray} from '@modifi/colors'

export default createGlobalStyle`
  html {
    color: ${darkGray};
  }
`
